import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomePage.vue';
import Coverage from '../views/CoveragePage.vue';
import EventsGallery from '@/views/EventsGallery.vue';
import ServicesPage from '@/views/ServicesPage.vue';
import PartnerPage from '@/views/PartnerPage.vue';
import CasesPage from '@/views/CasesPage.vue';
import BlogsPage from '@/views/BlogsPage.vue';
import AuthForm from '@/components/AuthForm.vue'; 
import BlogFile from '@/components/BlogFile.vue';
import ContactPage from '@/views/ContactPage.vue';
import SupportPage from '@/views/SupportPage.vue';
import SalesPage from '@/views/SalesPage.vue';
import GeneralPage from '@/views/GeneralPage.vue';
import SaleQuote from '@/components/SaleQuote.vue';
import BlogPage from '@/components/BlogPage.vue';
import DedicatedLines from '@/components/DedicatedLines.vue';
import BroadbandAccess from '@/components/BroadbandAccess.vue';
import WirelessConnect from '@/components/WirelessConnect.vue';
import PartnersForm from '@/components/PartnersForm.vue';
import TestimonialPage from '@/components/TestimonialPage.vue';
import TestimonialMx from '@/components/TestimonialMx.vue';
import AustraliaPage from '@/components/AustraliaPage.vue';
import AustriaPage from '@/components/AustriaPage.vue';
import BermudaPage from '@/components/BermudaPage.vue';
import BulgariaPage from '@/components/BulgariaPage.vue';
import ChilePage from '@/components/ChilePage.vue';
import DominicanRepublic from '@/components/DominicanRepublic.vue';
import EthiopiaPage from '@/components/EthiopiaPage.vue';
import IndonesiaPage from '@/components/IndonesiaPage.vue';
import JapanPage from '@/components/JapanPage.vue';
import MexicoPage from '@/components/MexicoPage.vue';
import MozambiquePage from '@/components/MozambiquePage.vue';
import NigeriaPage from '@/components/NigeriaPage.vue';
import QatarPage from '@/components/QatarPage.vue';
import SouthAfrica from '@/components/SouthAfrica.vue';
import TurkeyPage from '@/components/TurkeyPage.vue';
import VietnamPage from '@/components/VietnamPage.vue';
import CasesLebonan from '@/components/CasesLebonan.vue';
import CasesColgate from '@/components/CasesColgate.vue';
import CasesFiji2 from '@/components/CasesFiji2.vue';

import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
import LegalPage from '@/components/LegalPage.vue';
import NsocPage from '@/components/NsocPage.vue';
import AboutPage from '@/views/AboutPage.vue';
import MainCorporatePresentation from '@/components/MainCorporatePresentation.vue';
import AntiguaPage from '@/components/AntiguaPage.vue';
import AfghanistanPage from '@/components/AfghanistanPage.vue';
import AndorraPage from '@/components/AndorraPage.vue';
import AngolaPage from '@/components/AngolaPage.vue';
import AlbaniaPage from '@/components/AlbaniaPage.vue';
import AlgeriaPage from '@/components/AlgeriaPage.vue';
import ArgentinaPage from '@/components/ArgentinaPage.vue';
import ArmeniaPage from '@/components/ArmeniaPage.vue';
import AzerbaijanPage from '@/components/AzerbaijanPage.vue';
import BahamasPage from '@/components/BahamasPage.vue';
import BahrainPage from '@/components/BahrainPage.vue';
import BangladeshPage from '@/components/BangladeshPage.vue';
import BelarusPage from '@/components/BelarusPage.vue';
import BelgiumPage from '@/components/BelgiumPage.vue';
import BelizePage from '@/components/BelizePage.vue';
import BeninPage from '@/components/BeninPage.vue';
import BhutanPage from '@/components/BhutanPage.vue';
import BoliviaPage from '@/components/BoliviaPage.vue';
import BosinaAndHerzegovina from '@/components/BosinaAndHerzegovina.vue';
import BrazilPage from '@/components/BrazilPage.vue';
import CoveragePageNotFound from '@/components/CoveragePageNotFound.vue';
import CanadaPage from '@/components/CanadaPage.vue';




const routes = [
  { path: '/', component: Home },
  { path: '/coverage', component: Coverage },
  { path: '/events-gallery', component: EventsGallery},
  { path: '/services', component: ServicesPage},
  { path: '/partner-center', component: PartnerPage},
  { path: '/cases', component: CasesPage},
  { path: '/blogFile', component: BlogsPage},
  { path: '/auth', component: AuthForm },
  { path: '/blogs', component: BlogFile },
  { path: '/contact', component: ContactPage},
  { path: '/contact/support' , component: SupportPage},
  { path: '/contact/sales' , component: SalesPage },
  { path: '/contact/general' , component: GeneralPage},
  { path: '/contact/quote' , component: SaleQuote},
  { path: '/blog/:id' , component: BlogPage},
  { path: '/services/dedicated-lines' , component: DedicatedLines },
  { path: '/services/business-broadband', component: BroadbandAccess},
  { path: '/services/Wireless-connect' , component: WirelessConnect},
  { path: '/contact/partners' , component: PartnersForm },
  { path: '/testimonials' , component: TestimonialPage },
  { path: '/testimonials/mx' , component: TestimonialMx },
  { path: '/coverage/Australia' , component: AustraliaPage},
  { path: '/coverage/antiguaandbarbuda' , component: AntiguaPage},
  { path: '/coverage/Austria' , component: AustriaPage},
  { path: '/coverage/Bermuda' , component: BermudaPage},
  { path: '/coverage/Afghanistan' , component: AfghanistanPage},
  { path: '/coverage/Andorra' , component: AndorraPage},
  { path: '/coverage/Angola' , component: AngolaPage},
  { path: '/coverage/Azerbaijan' , component: AzerbaijanPage},
  { path: '/coverage/Bahamas' , component: BahamasPage},
  { path: '/coverage/Bahrain' , component: BahrainPage},
  { path: '/coverage/bosniaandherzegovina' , component: BosinaAndHerzegovina},
  { path: '/coverage/bangladesh' , component: BangladeshPage},
  { path: '/coverage/Belarus' , component: BelarusPage},
  { path: '/coverage/Belgium' , component: BelgiumPage},
  { path: '/coverage/Belize' , component: BelizePage},
  { path: '/coverage/Benin' , component: BeninPage},
  { path: '/coverage/Bhutan' , component: BhutanPage},
  { path: '/coverage/Albania' , component: AlbaniaPage},
  { path: '/coverage/Algeria' , component: AlgeriaPage},
  { path: '/coverage/Argentina' , component: ArgentinaPage},
  { path: '/coverage/Armenia' , component: ArmeniaPage},
  { path: '/coverage/Bulgaria' , component: BulgariaPage},
  { path: '/coverage/Chile' , component: ChilePage},
  { path: '/coverage/dominicanrepublic' , component: DominicanRepublic},
  { path: '/coverage/Ethiopia' , component: EthiopiaPage},
  { path: '/coverage/Indonesia' , component: IndonesiaPage},
  { path: '/coverage/Japan' , component: JapanPage},
  { path: '/coverage/Mexico' , component: MexicoPage},
  { path: '/coverage/Mozambique' , component: MozambiquePage},
  { path: '/coverage/Nigeria' , component: NigeriaPage},
  { path: '/coverage/Qatar' , component: QatarPage},
  { path: '/coverage/SouthAfrica' , component: SouthAfrica},
  { path: '/coverage/bolivia' , component: BoliviaPage},
  { path: '/coverage/Turkey' , component: TurkeyPage},
  { path: '/coverage/Brazil' , component: BrazilPage},
  { path: '/coverage/Vietnam' , component: VietnamPage},
  { path: '/cases/lebanon' , component: CasesLebonan},
  { path: '/cases/argentina' , component: CasesColgate},
  { path: '/cases/fiji' , component: CasesFiji2},
  { path: '/privacy-policy' , component: PrivacyPolicy},
  { path: '/legal-policy' , component: LegalPage},
  { path: '/global-nsoc' , component: NsocPage},
  { path: '/coverage/india' , component: CoveragePageNotFound},
  { path: '/coverage/cameroon', component: CoveragePageNotFound },
{ path: '/coverage/canada', component: CanadaPage },
{ path: '/coverage/capeverde', component: CoveragePageNotFound },
{ path: '/coverage/caymanislands', component: CoveragePageNotFound },
{ path: '/coverage/centralafricanrepublic', component: CoveragePageNotFound },
{ path: '/coverage/chad', component: CoveragePageNotFound },
{ path: '/coverage/china', component: CoveragePageNotFound },
{ path: '/coverage/christmasisland', component: CoveragePageNotFound },
{ path: '/coverage/cocoskeelingislands', component: CoveragePageNotFound },
{ path: '/coverage/colombia', component: CoveragePageNotFound },
{ path: '/coverage/comoros', component: CoveragePageNotFound },
{ path: '/coverage/congorepublicofbrazzaville', component: CoveragePageNotFound },
{ path: '/coverage/congodemocraticrepublicofthekinshasa', component: CoveragePageNotFound },
{ path: '/coverage/cookislands', component: CoveragePageNotFound },
{ path: '/coverage/costarica', component: CoveragePageNotFound },
{ path: '/coverage/cotedivoire', component: CoveragePageNotFound },
{ path: '/coverage/croatia', component: CoveragePageNotFound },
{ path: '/coverage/cuba', component: CoveragePageNotFound },
{ path: '/coverage/curacao', component: CoveragePageNotFound },
{ path: '/coverage/cyprus', component: CoveragePageNotFound },
{ path: '/coverage/czechrepublic', component: CoveragePageNotFound },
{ path: '/coverage/denmark', component: CoveragePageNotFound },
{ path: '/coverage/djibouti', component: CoveragePageNotFound },
{ path: '/coverage/dominica', component: CoveragePageNotFound },
{ path: '/coverage/ecuador', component: CoveragePageNotFound },
{ path: '/coverage/egypt', component: CoveragePageNotFound },
{ path: '/coverage/elsalvador', component: CoveragePageNotFound },
{ path: '/coverage/equatorialguinea', component: CoveragePageNotFound },
{ path: '/coverage/eritrea', component: CoveragePageNotFound },
{ path: '/coverage/estonia', component: CoveragePageNotFound },
{ path: '/coverage/falklandislandsmalvinas', component: CoveragePageNotFound },
{ path: '/coverage/faroeislands', component: CoveragePageNotFound },
{ path: '/coverage/fiji', component: CoveragePageNotFound },
{ path: '/coverage/finland', component: CoveragePageNotFound },
{ path: '/coverage/france', component: CoveragePageNotFound },
{ path: '/coverage/frenchguiana', component: CoveragePageNotFound },
{ path: '/coverage/frenchpolynesia', component: CoveragePageNotFound },
{ path: '/coverage/frenchsouthernterritories', component: CoveragePageNotFound },
{ path: '/coverage/gabon', component: CoveragePageNotFound },
{ path: '/coverage/gambia', component: CoveragePageNotFound },
{ path: '/coverage/georgia', component: CoveragePageNotFound },
{ path: '/coverage/germany', component: CoveragePageNotFound },
{ path: '/coverage/ghana', component: CoveragePageNotFound },
{ path: '/coverage/gibraltar', component: CoveragePageNotFound },
{ path: '/coverage/greece', component: CoveragePageNotFound },
{ path: '/coverage/greenland', component: CoveragePageNotFound },
{ path: '/coverage/grenada', component: CoveragePageNotFound },
{ path: '/coverage/guadeloupe', component: CoveragePageNotFound },
{ path: '/coverage/guam', component: CoveragePageNotFound },
{ path: '/coverage/guatemala', component: CoveragePageNotFound },
{ path: '/coverage/guernsey', component: CoveragePageNotFound },
{ path: '/coverage/guinea', component: CoveragePageNotFound },
{ path: '/coverage/guineabissau', component: CoveragePageNotFound },
{ path: '/coverage/guyana', component: CoveragePageNotFound },
{ path: '/coverage/haiti', component: CoveragePageNotFound },
{ path: '/coverage/heardislandandmcdonaldislands', component: CoveragePageNotFound },
{ path: '/coverage/holyseevaticancitystate', component: CoveragePageNotFound },
{ path: '/coverage/honduras', component: CoveragePageNotFound },
{ path: '/coverage/hongkong', component: CoveragePageNotFound },
{ path: '/coverage/hurgary', component: CoveragePageNotFound },
{ path: '/coverage/iceland', component: CoveragePageNotFound },
{ path: '/coverage/india', component: CoveragePageNotFound },
{ path: '/coverage/iranislamicrepublicof', component: CoveragePageNotFound },
{ path: '/coverage/iraq', component: CoveragePageNotFound },
{ path: '/coverage/ireland', component: CoveragePageNotFound },
{ path: '/coverage/isleofman', component: CoveragePageNotFound },
{ path: '/coverage/israel', component: CoveragePageNotFound },
{ path: '/coverage/italy', component: CoveragePageNotFound },
{ path: '/coverage/ivorycoast', component: CoveragePageNotFound },
{ path: '/coverage/jamaica', component: CoveragePageNotFound },
{ path: '/coverage/jersey', component: CoveragePageNotFound },
{ path: '/coverage/jordan', component: CoveragePageNotFound },
{ path: '/coverage/kazakhstan', component: CoveragePageNotFound },
{ path: '/coverage/kenya', component: CoveragePageNotFound },
{ path: '/coverage/kiribati', component: CoveragePageNotFound },
{ path: '/coverage/kosovo', component: CoveragePageNotFound },
{ path: '/coverage/kuwait', component: CoveragePageNotFound },
{ path: '/coverage/kyrgyzstan', component: CoveragePageNotFound },
{ path: '/coverage/laospeoplesdemocraticrepublic', component: CoveragePageNotFound },
{ path: '/coverage/latvia', component: CoveragePageNotFound },
{ path: '/coverage/lebanon', component: CoveragePageNotFound },
{ path: '/coverage/lesotho', component: CoveragePageNotFound },
{ path: '/coverage/liberia', component: CoveragePageNotFound },
{ path: '/coverage/libya', component: CoveragePageNotFound },
{ path: '/coverage/liechtenstein', component: CoveragePageNotFound },
{ path: '/coverage/lithuania', component: CoveragePageNotFound },
{ path: '/coverage/luxembourg', component: CoveragePageNotFound },
{ path: '/coverage/macau', component: CoveragePageNotFound },
{ path: '/coverage/macedonia', component: CoveragePageNotFound },
{ path: '/coverage/madagascar', component: CoveragePageNotFound },
{ path: '/coverage/malawi', component: CoveragePageNotFound },
{ path: '/coverage/malaysia', component: CoveragePageNotFound },
{ path: '/coverage/maldives', component: CoveragePageNotFound },
{ path: '/coverage/mali', component: CoveragePageNotFound },
{ path: '/coverage/malta', component: CoveragePageNotFound },
{ path: '/coverage/marshallislands', component: CoveragePageNotFound },
{ path: '/coverage/martinique', component: CoveragePageNotFound },
{ path: '/coverage/mauritania', component: CoveragePageNotFound },
{ path: '/coverage/mauritius', component: CoveragePageNotFound },
{ path: '/coverage/mayotte', component: CoveragePageNotFound },
{ path: '/coverage/micronesiafederatedstatesof', component: CoveragePageNotFound },
{ path: '/coverage/moldovarepublicof', component: CoveragePageNotFound },
{ path: '/coverage/monaco', component: CoveragePageNotFound },
{ path: '/coverage/mongolia', component: CoveragePageNotFound },
{ path: '/coverage/montenegro', component: CoveragePageNotFound },
{ path: '/coverage/montserrat', component: CoveragePageNotFound },
{ path: '/coverage/morocco', component: CoveragePageNotFound },
{ path: '/coverage/myanmar', component: CoveragePageNotFound },
{ path: '/coverage/namibia', component: CoveragePageNotFound },
{ path: '/coverage/nauru', component: CoveragePageNotFound },
{ path: '/coverage/nepal', component: CoveragePageNotFound },
{ path: '/coverage/netherlands', component: CoveragePageNotFound },
{ path: '/coverage/netherlandsantilles', component: CoveragePageNotFound },
{ path: '/coverage/newcaledonia', component: CoveragePageNotFound },
{ path: '/coverage/newzealand', component: CoveragePageNotFound },
{ path: '/coverage/nicaragua', component: CoveragePageNotFound },
{ path: '/coverage/niger', component: CoveragePageNotFound },
{ path: '/coverage/niue', component: CoveragePageNotFound },
{ path: '/coverage/norfolkisland', component: CoveragePageNotFound },
{ path: '/coverage/northernmarianaislands', component: CoveragePageNotFound },
{ path: '/coverage/norway', component: CoveragePageNotFound },
{ path: '/coverage/oman', component: CoveragePageNotFound },
{ path: '/coverage/pakistan', component: CoveragePageNotFound },



  { path: '/about-us' , component: AboutPage},
  { path: '/maincorporatepresentation' , component: MainCorporatePresentation}
  

  

  



];

const router = createRouter({
  history: createWebHistory(),
  routes,  
});

export default router;
